import {FunctionSpec} from '@mintdata/mint-kit/api/decorators/Function';
import bind from 'bind-decorator';

export class FunctionMap
{
    private _propNameToSpec:any = {};

    @bind
    public getOrCreateFunctionSpec(propName:string):FunctionSpec
    {
        let fs = this._propNameToSpec[propName];

        if( !fs )
        {
            fs = new FunctionSpec();
            this._propNameToSpec[propName] = fs;
        }

        return fs;
    }

    @bind
    public findFunctionSpec(propName:string):FunctionSpec | null
    {
        return this._propNameToSpec[propName];
    }
}
